import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { KpiQuery, KpiResult } from '@/api-client/models/utilization/Contracts'
import { useKpis, useKpisFromQuery } from '../composables/useKpis'
import { computed, toRefs, watch } from 'vue'
import { calculateKpiPerRoomGroup } from '../calculateKpi'
import { useI18n } from 'vue-i18n'
import KPICard from './cards/KPICard.vue'
import { COCLASSGROUPS } from '@/interfaces/coclass.interface'

interface Props {
  fullscreen: boolean
  query: KpiQuery
}

type Emits = {
  (e: 'toggleShowOnMap'): void
  (e: 'missingData', missingData: boolean)
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KPIQuery',
  props: {
    fullscreen: { type: Boolean },
    query: {}
  },
  emits: ["toggleShowOnMap", "missingData"],
  setup(__props: any, { emit: __emit }) {

const { locale } = useI18n()
const props = __props
const query = computed(() => props.query)
const emits = __emit
const kpis = useKpis()
const { toggleKpiSelection } = kpis
const { kpiSettingsMap, selectedKpiType, isShowOnMapEnabled, showOnMapEnabled } = toRefs(kpis)

const { kpiValues, isLoading, missingData } = useKpisFromQuery(query)
watch(missingData, (missing) => {
  emits('missingData', missing)
})

function getDetails(kpi: KpiResult): { header: string[]; rows: any[][] } {
  const perRoomGroup = calculateKpiPerRoomGroup(kpi)
  const header = [
    { sv: 'Rumstyp', en: 'Room type' },
    { sv: 'Antal rum', en: 'Rooms' },
    { sv: 'Andel', en: 'Part' }
  ] as Record<string, string>[]

  const rows = perRoomGroup.map(({ roomGroup, numberOfSpaces, value }) => [
    roomGroup ? COCLASSGROUPS[roomGroup][locale.value] : 'Okänd',
    numberOfSpaces,
    formatPercentage(value)
  ])

  return { header: header.map((x) => x[locale.value]), rows }
}

function formatPercentage(value: number | string): string {
  return typeof value === 'number' ? `${Math.round(value * 100)}%` : value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kpiValues), (kpi) => {
    return (_openBlock(), _createBlock(KPICard, {
      key: kpi.kpi,
      color: _unref(kpiSettingsMap)?.[kpi.kpi]?.color!,
      kpi: kpi.summary.value,
      kpiFormat: { format: { type: 'intl-number', style: 'percent' } },
      kpiDetails: getDetails(kpi),
      fullscreen: _ctx.fullscreen,
      isLoading: _unref(isLoading),
      numberOfSpaces: kpi.summary.metadata.numberOfSpaces,
      title: _unref(kpiSettingsMap)?.[kpi.kpi]?.title[_unref(locale)] ?? '',
      info: _unref(kpiSettingsMap)?.[kpi.kpi]?.info?.[_unref(locale)] ?? '',
      showOnMap: _unref(selectedKpiType) === kpi.kpi,
      showOnMapEnabled: _unref(showOnMapEnabled) && _unref(isShowOnMapEnabled)(_unref(kpiSettingsMap)?.[kpi.kpi]!),
      kpiType: kpi.kpi,
      onToggleShowOnMap: ($event: any) => (_unref(toggleKpiSelection)(kpi.kpi))
    }, null, 8, ["color", "kpi", "kpiDetails", "fullscreen", "isLoading", "numberOfSpaces", "title", "info", "showOnMap", "showOnMapEnabled", "kpiType", "onToggleShowOnMap"]))
  }), 128))
}
}

})